// extracted by mini-css-extract-plugin
export default {"EventScheduleFooter":"EventScheduleFooter-module-b0b06ee46485d2381e37"};